import type { IntlShape } from "@formatjs/intl";
import { Flex, Statistic } from "antd";
import { formatHours } from "../../common/utils/formatHours.ts";
import type { TurbineWorkSummary } from "../generated-axios-client";

// the totals the project report and the turbine work summary share
export type WorkOrderTotals = Omit<TurbineWorkSummary, "technicians">;

type WorkOrderTotalsStatisticsProps = {
  intl: IntlShape;
  totals: WorkOrderTotals | null;
  loading: boolean;
};

export const WorkOrderTotalsStatistics = ({
  intl,
  totals,
  loading,
}: WorkOrderTotalsStatisticsProps) => {
  const hourStatistics = [
    { titleId: "work_order_totals_stat_check_in_time", hours: totals?.check_in_hours },
    { titleId: "work_order_totals_stat_standby_time", hours: totals?.standby_hours },
    {
      titleId: "work_order_totals_stat_estimated_task_time",
      hours: totals?.estimated_task_hours,
    },
    {
      titleId: "work_order_totals_stat_logged_task_time",
      hours: totals?.logged_task_hours,
    },
  ];

  return (
    <Flex gap="large" wrap>
      <Statistic
        title={intl.formatMessage({ id: "work_order_totals_stat_work_orders" })}
        value={totals?.completed_work_order_count ?? 0}
        suffix={`/ ${totals?.work_order_count ?? 0}`}
        loading={loading}
      />
      <Statistic
        title={intl.formatMessage({ id: "work_order_totals_stat_tasks" })}
        value={totals?.completed_task_count ?? 0}
        suffix={`/ ${totals?.task_count ?? 0}`}
        loading={loading}
      />
      {hourStatistics.map(({ titleId, hours }) => (
        <Statistic
          key={titleId}
          title={intl.formatMessage({ id: titleId })}
          value={formatHours(hours ?? 0)}
          loading={loading}
        />
      ))}
    </Flex>
  );
};
